import isEmpty from './isEmpty'

const isNilOrEmpty = <T>(input: T): boolean => input == null || isEmpty(input)

export const isNotNilOrEmpty = <T>(input: T): boolean => !(input == null || isEmpty(input))

export default isNilOrEmpty
